
import PropTypes from 'prop-types'
import { Grid, Typography } from '@mui/material'

const safe = (value) =>
  value !== null && value !== undefined && value !== '' ? value : '-'

const ReadOnly = ({ label, value }) => (
  <Grid item xs={12} sm={6} md={12}>
    {/* Label */}
    <Typography
      sx={{
        color: '#98B6BE',
        fontFamily: 'Inter',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '18px',
        mb: '2px',
      }}>
      {label}
    </Typography>

    {/* Value */}
    <Typography
      sx={{
        color: '#111827',
        fontFamily: 'Inter',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '18px',
      }}>
      {safe(value)}
    </Typography>
  </Grid>
)

ReadOnly.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
}

export default ReadOnly
